var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96884 8.31337C5.48997 11.6264 8.19662 14.2604 11.5617 15.6883L12.1011 15.9287C13.3353 16.4785 14.786 16.0608 15.5387 14.9388L16.2437 13.8881C16.4728 13.5465 16.4031 13.0864 16.0829 12.8282L13.6923 10.8995C13.3411 10.6163 12.8248 10.6822 12.5562 11.0447L11.8166 12.0426C9.91895 11.1066 8.37826 9.56586 7.44217 7.66818L8.4401 6.92864C8.80257 6.66002 8.86855 6.14368 8.58527 5.79254L6.65659 3.40184C6.39835 3.08174 5.93837 3.01192 5.59678 3.24097L4.53885 3.95033C3.40988 4.70733 2.99445 6.17007 3.557 7.40747L3.96822 8.31203L3.96884 8.31337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.44746a13ddd6008ff8aabbe3e4a06600.svg";
export { ForwardRef as ReactComponent };